import { InputNumber } from "@mimber/ui-web"
import { FormItem } from "react-hook-form-antd"
import { useFormContext, FieldValues, FieldPath } from "react-hook-form"
import type { InputNumberFieldProps } from "./InputNumberField.types"

/**
 * InputNumberField component that integrates React Hook Form with Ant Design InputNumber
 * Uses react-hook-form-antd's FormItem for seamless integration
 */
export function InputNumberField<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>,
>({
  name,
  control,
  label,
  required,
  help,
  placeholder,
  disabled,
  min,
  max,
  step,
  precision,
  size,
  variant,
  prefix,
  suffix,
  addonBefore,
  addonAfter,
  formatter,
  parser,
  controls,
  stringMode,
}: InputNumberFieldProps<TFieldValues, TName>) {
  const { control: contextControl } = useFormContext<TFieldValues>()
  const formControl = control || contextControl

  return (
    <FormItem
      control={formControl}
      name={name}
      label={label}
      required={required}
      help={help}
    >
      <InputNumber
        placeholder={placeholder}
        disabled={disabled}
        min={min}
        max={max}
        step={step}
        precision={precision}
        size={size}
        variant={variant}
        prefix={prefix}
        suffix={suffix}
        addonBefore={addonBefore}
        addonAfter={addonAfter}
        formatter={formatter}
        parser={parser}
        controls={controls}
        stringMode={stringMode}
        style={{ width: "100%" }}
      />
    </FormItem>
  )
}
